
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#D80027"}},[_c('path',{attrs:{"d":"M0 85.331h512v341.326H0z"}}),_c('path',{attrs:{"d":"M0 85.331h512v341.337H0z"}})]),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M189.746 160.439l-15.739-15.741-10.494 10.494-10.493-10.494-15.741 15.741 10.494 10.493-10.495 10.494 15.74 15.741 10.494-10.494 10.495 10.494 15.739-15.741-10.494-10.494zM211.478 85.331H512v111.315H211.478z"}})]),_c('path',{attrs:{"fill":"#6DA544","d":"M211.478 315.353H512v111.304H211.478z"}})])
          )
        }
      }
    